import { render, staticRenderFns } from "./MojarOld.vue?vue&type=template&id=5640d8ed"
import script from "./MojarOld.vue?vue&type=script&lang=js"
export * from "./MojarOld.vue?vue&type=script&lang=js"
import style0 from "./MojarOld.vue?vue&type=style&index=0&id=5640d8ed&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports